<template lang="pug">
#membershipVue(class="membership pt-4 lg1024:pt-8", data-qa="step0-membership-block")
  template(v-if="!noMemberTrigger")
    div(class="lg1024:pb-6 pb-4") {{ $t("unauth_membership_text") }}
    div(v-if="invitation", class="lg1024:w-3/4 w-full flex flex-col lg1024:flex-row lg1024:gap-3 pb-6 max-[480px]:pb-4")
      div(class="flex flex-col justify-end lg1024:w-1/2 w-full max-w-[184px] max-[480px]:max-w-[100%]")
        label(class="text-[#75828B] text-[14px] whitespace-nowrap", for="memberId") {{ $t('membership_placeholder') }}
        input#memberId(
          type="text",
          data-qa="step0-membership-input",
          v-mask="['#####','######','#######']",
          v-model="memberId",
          maxlengt="7",
          class="w-full border border-gray-2 p-3 mt-1 input-wrap",
          :class="{ 'has-error': memberError !== '' && !focused && memberName === '' }",
          style="letter-spacing: 0.15em;",
          placeholder="________",
          @focus="focused = true",
          @blur="focused = false"
        )
        .pt-2.text-sm.text-accentColor(v-if="memberError !== '' && !focused && memberName === ''") {{ memberError }}
      span(class="lg1024:w-1/2 w-full lg1024:pl-2 font-medium")
        //- Skeletor(v-if="memberLoading", class="w-1/3", :height="'24px'")
        //- span(v-else, v-html="memberName")
    //- div(v-else, class="lg1024:w-3/4 w-full flex gap-3 pt-2 font-medium")
      Skeletor(v-if="memberLoading", class="w-1/3", :height="'24px'")
      span(v-else, v-html="memberName")
    .member(v-if="memberName !== ''", class="lg1024:w-3/4 w-full flex flex-row gap-3 items-center p-4", data-qa="step0-membership-member-info")
      .avatar.pr-4(:style="{ backgroundImage: memberAvatar ? 'url(https://ru.coral.club'+ memberAvatar+')' : ''}")
      .memberContent.text-sm
        div {{ $t('unauth_yourmember') }}
        .font-medium {{ memberName }}
    UiButton.member-ship__nomember(v-else, analytics-id="analytics-157", @click="noMember", color="outline", class="max-w-[273px] max-[480px]:max-w-[100%]", data-qa="step0-nomember-btn") {{ $t('unauth_nomember') }}
  UiButton.member-ship__trigger(v-else, @click="noMemberTrigger = false", color="outline", class="max-w-[273px] max-[480px]:max-w-[100%]", data-qa="step0-hasmember-btn") {{ $t('unauth_step1') }}
</template>

<script>
import UiButton from '@/components/ui/UiButton.vue'

export default {
  name: 'MembershipBlock',
  components: { UiButton },
  data() {
    return {
      invitation: true,
      memberId: '',
      memberName: '',
      memberAvatar: '',
      memberTaken: false,
      memberLoading: false,
      memberError: '',
      focused: false,
      noMemberTrigger: false,
    }
  },
  watch: {
    async invitation(newValue) {
      this.memberTaken = false
      // this.memberName = this.memberId.length ? '<span class="text-sm text-accentColor">' + this.$t('fill_that_field') + '</span>' : '';
      this.memberId = ''
      if (!newValue) {
        this.memberLoading = true
        try {
          const response = await this.$axios.get('/recommendMember')
          if (!response.data.error) {
            if (response.data.result) {
              this.memberName = response.data.result.memberName
              this.memberId = response.data.result.memberId
              this.memberTaken = true
              this.$store.commit(
                'UpdateMemberId',
                response.data.result.memberId
              )
            } else {
              this.memberTaken = false
            }
          } else {
            console.log(response.data.error)
          }
        } catch (err) {
          console.log(err)
        }
        this.memberLoading = false
      }
    },
    async memberId(newValue) {
      this.memberTaken = false
      this.memberName = ''

      // this.memberName = this.memberId.length ? '<span class="text-sm text-accentColor">' + this.$t('fill_that_field') + '</span>' : '';
      if (newValue.length > 5 && this.invitation) {
        if (newValue.length > 7) {
          this.memberId = this.memberId.substring(0, 7)
        } else {
          this.memberLoading = true
          try {
            const response = await this.$axios.get('/checkMember', {
              params: {
                memberId: newValue,
              },
            })
            if (!response.data.error) {
              if (response.data.result) {
                this.memberName = response.data.result.memberName
                this.memberAvatar = response.data.result.memberAvatar
                this.memberTaken = true
              } else {
                this.memberTaken = false
                this.memberError = this.$t('member_notfound')
              }
            } else {
              console.log(response.data.error)
              this.memberError = this.$t('member_notfound')
              this.memberTaken = false
            }
          } catch (err) {
            console.log(err)
            this.memberTaken = false
            this.memberName = ''
            this.memberAvatar = ''
            this.memberError = this.$t('member_wrongid')
          }
          this.memberLoading = false
          if (this.memberTaken)
            this.$store.commit('UpdateMemberId', this.memberId)
        }
      } else {
        this.$store.commit('UpdateMemberId', false)
        // this.memberName = this.memberId.length ? '<span class="text-sm text-accentColor">' + this.$t('fill_that_field') + '</span>' : '';
        this.memberTaken = false
      }
    },
    memberTaken(newValue) {
      if (newValue) {
        this.$emit('change', this.memberId)
      } else {
        this.$emit('change', false)
        this.$store.commit('UpdateMemberId', false)
      }
    },
  },
  beforeMount() {
    // this.memberName = this.memberId.length ? '<span class="text-sm text-accentColor">' + this.$t('fill_that_field') + '</span>' : '';
    if (window.refMember) {
      this.memberId = window.refMember
    }
  },
  methods: {
    noMember() {
      this.noMemberTrigger = true
      this.memberError = ''
      this.memberId = ''
      this.$emit('change', '')
      this.$store.commit('UpdateMemberId', '')
    },
  },
}
</script>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

label {
  display: flex;
  align-items: center;
}
input[type='radio'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 1px;
  margin-right: 8px;
  width: 16px;
  height: 19px;
}
input[type='radio']:focus {
  outline: none;
}
input[type='radio']:after {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 1px solid #bec1c6;
}

input[type='radio']:checked:after {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  background-color: #fff;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 3px solid #ff585d;
}

.member {
  border: 1px solid #feecb9;
  background: #fffcf5;
}

.member .avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f2f2f2;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
